var map = {
	"./2com-red.jpg": 2889,
	"./2red.jpg": 7978,
	"./2redbe.jpg": 2935,
	"./2redch.jpg": 4465,
	"./3greenwo.jpg": 6761,
	"./4com-gold.jpg": 1376,
	"./4goldwo.jpg": 7368,
	"./5com-gray.jpg": 9392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5703;